import React, { useEffect, useRef, useState } from "react";
import Home from "./Pages/Home";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import {
    BrowserRouter,
    Route,
    Routes
} from "react-router-dom";
import Stores from "./Pages/Stores";
import Drawer from "./Components/Layout/Drawer";
import Cart from "./Components/Layout/Cart/Cart";
import { useCartContext } from "./Contexts/CartContext";
import { useOrderTypeContext } from "./Contexts/OrderTypeContext";
import { useLoginContext } from "./Contexts/LoginContext";
import Modal from "./Components/Layout/Modal";
import Checkout from "./Pages/Checkout";
import CartConference from "./Components/Layout/Cart/CartConference";
import { useLayoutContext } from "./Contexts/LayoutContext";
import { useStoreContext } from "./Contexts/StoreContext";
import Badge from "./Components/Layout/Badge";
import LoadingMain from "./Components/Layout/LoadingMain";
import { formatCartId, formatCurrentAddress } from "./Utils/Formatters";
import Offline from "./Components/Layout/Offine";
import ProofPayment from "./Components/Layout/Cart/ProofPayment";
import { useCartHook } from "./Hooks/CartHook";
import { MdOutlineTableRestaurant } from "react-icons/md";
import { convertDateToTimestamp, isIOS, isPastHours } from "./Utils/Helpers";
import TableChoice from "./Components/Layout/Product/TableChoice";
import LoginStoreCounter from "./Components/Layout/LoginStoreCounter";
import LoginBasic from "./Components/Layout/LoginBasic";
import OrderPlaced from "./Pages/OrderPlaced";
import ProfileEditData from "./Pages/Profile/ProfileEditData";
import ProfileOrders from "./Pages/Profile/ProfileOrders";
import ProfileAddresses from "./Pages/Profile/ProfileAddresses";
import ProfileCards from "./Pages/Profile/ProfileCards";
import ProfileHome from "./Pages/Profile/ProfileHome";
import Profile from "./Pages/Profile/Profile";
import AppRouter from "./Pages/AppRouter";
import MainMenu from "./Components/Layout/MainMenu";
import OrdersToday from "./Components/Layout/OrdersToday";
import { getOrderColorByStatusId } from "./Utils/Constants/Order";
import { TbClock, TbMapPin } from "react-icons/tb";
import OrderDetails from "./Components/Layout/Checkout/OrderDetails";
import { ORDER_TYPE_ICONS, ORDER_TYPE_LABELS, ORDER_TYPE_STORE_COUNTER_ID, updateServiceLabels } from "./Utils/Constants/Service";
import ProductView from "./Pages/ProductView";
import { TokenManager } from './Services/TokenManager';
import Start from "./Pages/Start";
import TakeoutModeOptions from "./Components/Layout/TakeoutModeOptions";
import { useTranslation } from "react-i18next";
import { useStoreHook } from "./Hooks/StoreHook";

// import SwipeableDrawer from '@mui/material/SwipeableDrawer';

function App() {

    const { t } = useTranslation();
    const { mainLoading, company, versionFront, showMainMenu, setShowMainMenu, showTodayOrders, setShowTodayOrders, showStart, setShowStart } = useLayoutContext();
    const { cartConference, cartDisplay, showCartIsFinished, setShowCartIsFinished, cartFinished, showConfirmTable, setShowConfirmTable, showOrderDetail, setShowOrderDetail, currentOrder, setCurrentOrder, loadingOrderDetail, setShowDoneEditingButton } = useCartContext();
    const { user, tokenErrorRemoveLogin } = useLoginContext();
    const { currentStore, cashier, requiredTable, currentAddress } = useStoreContext();
    const { removeOldCart, updatedFrontVersion, removeLogin } = useCartHook();
    const { loadTables } = useStoreHook();
    const { showCart, setShowCart, showCartConference, setShowCartConference } = useCartContext();
    const { orderType, isStoreCounter, isDinein, isDelivery, takeoutMode, showTakeoutModeOptions, setShowTakeoutModeOptions } = useOrderTypeContext();
    const { showLoginStoreCounter, setShowLoginStoreCounter, showLoginBasic, setShowLoginBasic, closeableLogin } = useLoginContext();
    const { isMobile } = useLayoutContext();
    const [ subtitleCartDrawer, setSubtitleCartDrawer ] = useState<any>('');
    const previousTokenRef = useRef(TokenManager.getGuestToken());

    //* Verificando e removendo comanda finalizada depois de 2 horas ou comparando os caixas
    const checkCartFinished = () => {
        const dateStr = cartFinished?.order?.created_at?.date;
        if (typeof dateStr === 'string' && dateStr.trim()) {
            const orderCreatedAtTimestamp = convertDateToTimestamp(dateStr);
            if (isPastHours(orderCreatedAtTimestamp) || (cashier && cashier?.id !== cartFinished?.order?.cashier_id)) {
                removeOldCart();
            }
        }
    }

    useEffect(() => {
        checkCartFinished();
        //* Verificando versão do frontend
        if(process.env.REACT_APP_VERSION !== versionFront) {
            updatedFrontVersion();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        checkCartFinished();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cashier]);

    useEffect(() => {
        //* Alterando o favicon do projeto com base na imagem da Company
        if (company) {
            updateServiceLabels(company);
            if (company.square_image) {
                const link = document.querySelector("link[rel='icon']") as HTMLLinkElement || document.createElement('link');
                link.rel = 'icon';
                link.href = company.square_image;
                document.head.appendChild(link);
            }

            //* Injeção dinâmica do GTM vindo da Company
            const env = process.env.REACT_APP_ENV;
            if (company.google_tag_manager && (env === 'prod' || env === 'prod-beta')) {
                import('react-gtm-module').then((TagManager) => {
                    TagManager.default.initialize({
                        gtmId: company.google_tag_manager,
                    });
                });
            }
        }
    }, [company]);

    useEffect(() => {
        if (requiredTable) {
            setShowConfirmTable(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requiredTable]);

    useEffect(() => {
        if (tokenErrorRemoveLogin === 'true') {
            TokenManager.setTokenErrorRemoveLogin('');
            removeLogin(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokenErrorRemoveLogin]);

    const handleCloseCart = () => {
        setShowCart(false);
        setShowDoneEditingButton(false);
    }

    useEffect(() => {
        if (currentStore && (
            (isStoreCounter && TokenManager.getToken() && previousTokenRef.current !== TokenManager.getToken())
            ||  (isDinein && currentStore.dinein_table_enabled && TokenManager.getToken())
        )) {
            loadTables();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [TokenManager.getToken()]);


    useEffect(() => {

        const IconOrderType = ORDER_TYPE_ICONS[orderType as keyof typeof ORDER_TYPE_ICONS];

        if (isStoreCounter && cartDisplay) {
            setSubtitleCartDrawer(
                <div className="flex gap-1">
                    <>
                        <Badge type="title" className="text-sm md:text-xs lowercase">nº { formatCartId(cartDisplay.display_id || cartDisplay.id) }</Badge>
                        {cartDisplay.table && <Badge type="title" outline className="text-sm md:text-xs gap-0.5"><MdOutlineTableRestaurant />{cartDisplay.table.name}</Badge>}
                    </>
                </div>
            )
        } else if (isDelivery) {
            setSubtitleCartDrawer(
                <div className="flex gap-2 items-center leading-none">
                    <div className="flex gap-0.5 items-center leading-none text-custom-primary h-max self-start">
                        <span className="leading-none"><IconOrderType size={16} /></span>
                        <span className="font-bold leading-none">{ORDER_TYPE_LABELS[orderType as keyof typeof ORDER_TYPE_LABELS]}</span>
                    </div>
                    {currentAddress &&
                        <div className="flex gap-0.5 items-center leading-none text-gray-400">
                            <span className="leading-none self-start"><TbMapPin size={13} /></span>
                            <span className="leading-none">{formatCurrentAddress(currentAddress, true)}</span>
                        </div>
                    }
                </div>
            )
        } else if (isDinein) {
            setSubtitleCartDrawer(
                <div className="flex gap-2 items-center leading-none">
                    <div className="flex gap-0.5 leading-none text-custom-primary self-start h-max">
                        <span className="leading-none"><IconOrderType size={16} /></span>
                        <span className="font-bold leading-none">{ORDER_TYPE_LABELS[orderType as keyof typeof ORDER_TYPE_LABELS]}</span>
                    </div>
                </div>
            )
        }

    }, [company, isStoreCounter, cartDisplay, isDinein, isDelivery, orderType, currentAddress]);

    return (
        <>
            <Offline />
            <BrowserRouter>

                <Modal open={mainLoading} className="max-w-xs m-4" closeable={false} onClose={() => {}}>
                    <LoadingMain />
                </Modal>

                <Routes>
                    <Route path="/" element={<Start />} />
                    <Route path="/lojas" element={<Stores />} />
                    <Route path="/perfil" element={<Profile />}>
                        <Route index element={<ProfileHome />} />
                        <Route path="dados-cadastrais" element={<ProfileEditData />} />
                        <Route path="meus-pedidos" element={<ProfileOrders />} />
                        <Route path="meus-enderecos" element={<ProfileAddresses />} />
                        <Route path="meus-cartoes" element={<ProfileCards />} />
                    </Route>
                    <Route path="/:order_type" element={<AppRouter />} />
                    <Route path="/:order_type/:slug" element={<AppRouter />}>
                        <Route index element={<Home />} />
                    </Route>
                    <Route path="/:order_type/:slug/produto/:slug_product" element={<AppRouter />}>
                        <Route index element={<ProductView />} />
                    </Route>
                    <Route path="/:order_type/:slug/mesa/:table_id" element={<AppRouter />}>
                        <Route index element={<Home />} />
                    </Route>

                    <Route path="/:order_type/:slug/checkout" element={<Checkout />} />
                    <Route path="/:order_type/:slug/order/:order_id/placed" element={<OrderPlaced />} />
                    <Route path="/:order_type/:slug/order/:order_id/view" element={<OrderPlaced />} />

                    <Route path="*" element={<AppRouter />} />
                </Routes>

                {/* CONFIRM TABLE */}
                <Drawer
                    open={showConfirmTable}
                    fromBottom={isMobile}
                    onClose={() => setShowConfirmTable(false)}
                    closeable={false}
                    >
                    <TableChoice 
                        title={isStoreCounter ? t('store_counter.table_choice.title') : t('checkout.table_choice.title')}
                        subtitle={isStoreCounter ? t('store_counter.table_choice.subtitle') : t('checkout.table_choice.subtitle')}
                        onShowConfirmTable={(e: boolean) => setShowConfirmTable(e)} 
                    />
                </Drawer>

                {/* CART */}
                <Drawer open={showCart}
                    title={isStoreCounter
                        ? user?.first_name
                        : t('layout.cart_title')
                    }
                    subtitle={subtitleCartDrawer}
                    fromBottom={isMobile} onClose={handleCloseCart}
                    >
                    <Cart onCloseCart={handleCloseCart} enablePolling showMinimumOrderValue />
                </Drawer>

                {/* START */}
                <Drawer open={showStart} onClose={() => setShowStart(false)} classNameCloseButton={'text-white md:text-gray-400 bg-black/20 hover:bg-black/35 active:bg-black/35 md:bg-transparent md:hover:bg-gray-100'}>
                    <Start showBackgroundImage={false} isInDrawer />
                </Drawer>

                {/* CART CONFERENCE */}
                {((!showConfirmTable && isIOS()) || !isIOS()) && //condição para remover conflitos na rolagem da listagem de mesas
                    <Drawer
                        open={showCartConference}
                        title={isStoreCounter
                            ? `${user?.first_name}, ${t('layout.check_your_order')}`
                            : `${user ? `${user?.first_name}, ${t('layout.check_your_cart').toLowerCase()}` : t('layout.check_your_cart')}`
                        }
                        subtitle={cartDisplay && <div className="flex gap-1"><Badge type="title" className="text-sm md:text-xs lowercase">nº { formatCartId(cartDisplay.display_id || cartDisplay.id) }</Badge> <Badge type="title" outline className="text-sm md:text-xs gap-0.5"><MdOutlineTableRestaurant />{cartDisplay.table?.name}</Badge></div>}
                        fromBottom={isMobile}
                        onClose={() => setShowCartConference(false)}
                        >
                        <CartConference cart={cartConference} onCloseCart={() => setShowCartConference(false)} />
                    </Drawer>
                }

                {/* BASIC LOGIN */}
                <Modal open={showLoginBasic} className="max-w-sm m-4" onClose={() => setShowLoginBasic(false)} closeable={false}>
                    <LoginBasic onClose={() => setShowLoginBasic(false)} />
                </Modal>

                {/* MAIN MENU */}
                <Drawer open={showMainMenu}
                    fromBottom={false} onClose={() => setShowMainMenu(false)}
                    className={'ml-2'}
                    >
                    <MainMenu />
                </Drawer>

                {/* <SwipeableDrawer
                    anchor="right" // ou "bottom", "right"
                    open={showMainMenu}
                    onClose={() => setShowMainMenu(false)}
                    onOpen={() => setShowMainMenu(true)}
                    disableDiscovery={true}
                    disableBackdropTransition={false}

                >
                    <div className="w-[98vw] h-dvh">
                        <MainMenu />
                    </div>
                </SwipeableDrawer> */}

                {/* ORDERS TODAY */}
                <Drawer open={showTodayOrders}
                    title={t('layout.today_orders_title')}
                    fromBottom={isMobile}
                    onClose={() => setShowTodayOrders(false)}
                    classNameChildren={'bg-gray-50 ring-1 ring-gray-100'}
                    >
                    <OrdersToday />
                </Drawer>
                
                {/* ORDER DETAILS */}
                <Drawer open={showOrderDetail}
                    title={`${loadingOrderDetail
                        ? ''
                        : `${currentOrder?.type === ORDER_TYPE_STORE_COUNTER_ID ? `${t('layout.title_with_number_comanda')} ${formatCartId(currentOrder?.cart?.display_id || currentOrder?.cart?.id )}` : `${t('layout.title_with_number_order')} ${formatCartId(currentOrder?.id)}`}`
                    }`}
                    subtitle={
                        loadingOrderDetail
                            ?
                                <div className="flex gap-1 animate-pulse">
                                    <div className="bg-gray-200 h-5 w-20 rounded"></div>
                                    <div className="bg-gray-200 h-5 w-28 rounded"></div>
                                </div>
                            : currentOrder &&
                                <div className='flex items-center gap-1'>
                                    <Badge outline type={getOrderColorByStatusId(currentOrder.status)} className="text-xs leading-none py-1">{ currentOrder.status_name }</Badge>
                                    <Badge outline className="text-xs gap-0.5 capitalize text-normal pl-1 leading-none py-1"><TbClock /><span>{currentOrder.created_at_formatted}</span></Badge>
                                </div>
                    }
                    fromBottom={false}
                    className={isMobile ? 'ml-2' : ''}
                    onClose={() => {
                        setCurrentOrder(false);
                        setShowOrderDetail(false);
                    }}
                    >
                        <OrderDetails order={currentOrder} loading={loadingOrderDetail} onClose={() => setCurrentOrder(false)} />
                </Drawer>

                {/* MODAL LOGIN STORE_COUNTER */}
                <Modal open={showLoginStoreCounter} className="max-w-sm m-4" onClose={() => setShowLoginStoreCounter(false)} closeable={closeableLogin}>
                    <LoginStoreCounter onClose={() => setShowLoginStoreCounter(false)} closeable={closeableLogin} />
                </Modal>

            </BrowserRouter>

            {/* MODAL TakeoutModeOptions */}
            <Modal open={showTakeoutModeOptions} className="max-w-sm m-4" closeable={Boolean(takeoutMode)} onClose={() => setShowTakeoutModeOptions(false)}>
                <TakeoutModeOptions />
            </Modal>

            {/* CART FINISHED */}
            {cartFinished &&
                <Drawer open={showCartIsFinished}
                    title={t('store_counter.button_proof_label')}
                    fromBottom={isMobile} onClose={() => setShowCartIsFinished(false)}
                    >
                    <ProofPayment
                        order={cartFinished.order}
                        showButtonOpenNewCart={!cartDisplay && cashier}
                    />
                </Drawer>
            }

        </>
    );
}

export default App;